import React, { useState } from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import { ReactComponent as LinkedinIcon } from "../../../assets/svg/linkedInLogoSvg.svg";
import CustomRadioButton from "../common/customRadioBtn";
import Button from "../common/Button";
import linkedInUtils from "Pages/Dashboard/settings/ConnectedAccounts/LinkedInAccounts/common/linkedInUtils";

class AddLinkedInAccountPopupState {
  @observable showPopup = false;
  @observable cbk = () => {};
  @observable message = "";

  @action
  setShowPopup = (value = false) => {
    this.showPopup = value;
  };
}

const addLinkedInAccountPopupState = new AddLinkedInAccountPopupState();

const AddLinkedInAccountPopup = observer(() => {
  const [selectedAccountType, setSelectedAccountType] =
    useState("salesNavigator");

  if (!addLinkedInAccountPopupState?.showPopup) {
    return null;
  }

  const handleRadioChange = (e, id) => {
    setSelectedAccountType(id);
  };

  const linkedInBtnProps = {
    click: linkedInUtils.handleButtonClick
  };

  const salesNavigatorBtnProps = {
    click: linkedInUtils.handleSalesNavigatorButtonClick
  };

  const handleContinue = () => {
    if (selectedAccountType !== "standard") {
      salesNavigatorBtnProps.click();
    } else {
      linkedInBtnProps.click();
    }
    addLinkedInAccountPopupState.setShowPopup(false);
  };

  return (
    <div className="commonPopupWrapper linkedInAccountPopupWrapper">
      <div className="common-popup-mask" />
      <div className="commonPopupContainer linkedInAccountPopupContainer animated customzoomIn">
        <div className="closeIconContainer">
          <i
            className="material-icons commonPopupCloseIcon"
            onClick={() => addLinkedInAccountPopupState.setShowPopup(false)}
          >
            close
          </i>
        </div>

        <div className="commonPopupHeader linkedInAccountPopupHeader">
          <div className="linkedinIcon">
            <LinkedinIcon />
          </div>
          <div className="linkedinHeadingWrapper">
            <div className="headingTitle">Connect LinkedIn</div>
            <div className="chooseAccountType">
              Choose the account type you want to connect
            </div>
          </div>
        </div>
        <div className="commonPopupBody linkedInAccountPopupBody">
          <div className="linkedInAccountOptions">
            <div
              className={`linkedInAccountOption ${
                selectedAccountType === "standard" ? "selected" : ""
              }`}
              onClick={() => setSelectedAccountType("standard")}
            >
              <CustomRadioButton
                name="linkedInAccountType"
                id="standard"
                value=""
                checked={selectedAccountType === "standard"}
                radioOnchange={handleRadioChange}
              />
              <div className="optionContent">
                <div className="optionTitle">Standard/ Premium LinkedIn</div>
                <div className="optionDescription">
                  Automate profile views, requests, and messages.
                </div>
              </div>
            </div>
            <div
              className={`linkedInAccountOption ${
                selectedAccountType === "salesNavigator" ? "selected" : ""
              }`}
              onClick={() => setSelectedAccountType("salesNavigator")}
            >
              <CustomRadioButton
                name="linkedInAccountType"
                id="salesNavigator"
                value=""
                checked={selectedAccountType === "salesNavigator"}
                radioOnchange={handleRadioChange}
              />
              <div className="optionContent">
                <div className="optionTitle">
                  Sales Navigator{" "}
                  <span className="recommended">(recommended)</span>
                </div>
                <div className="optionDescription">
                  Unlock contact imports, advanced workflows, and higher
                  automation limits.
                </div>
              </div>
            </div>
          </div>
          <div className="linkedInAccountPopupFooter">
            <Button
              id="continueLinkedInBtn"
              name="continueLinkedInBtn"
              btnText="Continue"
              className="continueLinkedInBtn"
              type="button"
              click={handleContinue}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

export { addLinkedInAccountPopupState };
export default AddLinkedInAccountPopup;
